<template>
  <div class="container_brand">
    <HomeHead></HomeHead>
    <el-image
      :src="require('../../assets/images/brand/cost.jpg')"
      fit="fill"
    ></el-image>
    <el-row>
      <el-col :md="{ span: 20, offset: 2 }">
        <div class="pay_title">一、资费标准</div>
        <!-- <table class="func_table pay_txtcss">
          <thead>
            <tr>
              <th class="column1 top_left_radius">充值金额</th>
              <th class="column2">对应次数</th>
              <th class="column3 top_right_radius">单价</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>10000元</td>
              <td>5次</td>
              <td>2000元</td>
            </tr>
            <tr>
              <td>20000元</td>
              <td>12次</td>
              <td>1666元</td>
            </tr>
            <tr>
              <td colspan="3">
                长期合作请咨询：010-82800223-134，手机：13031051856
              </td>
            </tr>
          </tbody>
        </table> -->
        <p>请咨询：010-82800223-134，手机：13031051856</p>
        <div class="pay_title">二、费用扣除</div>
        <p>
          开一次会议扣除一次，会议开启扣除相应的次数，一个会议允许创建多个投票（目前没有限制投票次数）。
        </p>
        <p>
          特别提示：会议开启后，会议名称将不能修改，会议名称请在会议开启前进行确认。
        </p>
        <div class="pay_title">三、支付方式</div>
        <p>在线支付宝充值:个人中心->充值。</p>
        <p>线下付款联系电话：010-82800223-134，手机：13031051856。</p>
        <div class="pay_title">四、关于发票</div>
        <p>
          请您充值后三个工作日内联系客服索要发票，如未联系我们，我们会按照您当时充值的支付宝默认信息开具发票，即：若您的支付宝是个人的，如没有联系我们，并未提供开票信息的，我们就默认开具名称为个人的普通发票。联系电话：010-82800223-134，手机：13031051856。
        </p>
      </el-col>
    </el-row>
    <HomeFooter></HomeFooter>
  </div>
</template>
<script>
import HomeHead from '@/components/HomeHead.vue'
import HomeFooter from '@/components/HomeFooter.vue'
export default {
  components: {
    HomeHead,
    HomeFooter
  }
}
</script>
<style lang="less">
.pay_title {
  font-size: 24px;
  line-height: 30px;
  margin: 45px 0 24px 0;
}

.pay_txtcss {
  line-height: 24px;
  color: #5a5a5a;
}
.func_table {
  margin-bottom: 0px;
  background: #fff;
  border: 1px solid #c8c8c8;
  border-spacing: 0;
  border-radius: 10px;
  -moz-border-radius: 10px;
  -webkit-border-radius: 10px;
}
.func_table .column1 {
  width: 214px;
  border-right: 1px solid #23a053;
}
.func_table .column2 {
  padding-left: 40px;
  text-align: left;
  width: 214px;
  border-right: 1px solid #23a053;
}
.func_table .column3 {
  width: 214px;
  border-right: 1px solid #23a053;
}
.func_table th {
  text-align: center;
  background-color: #1faa46;
  color: white;
  font-weight: normal;
  font-size: 15px;
  line-height: 41px;
}
.func_table td {
  line-height: 36px;
  padding-left: 40px;
  border-right: 1px solid #e2e2e2;
  border-top: 1px solid #e2e2e2;
}
.top_left_radius {
  border-top-left-radius: 10px;
}
.top_right_radius {
  border-top-right-radius: 10px;
}
</style>
